export interface Locale {
    code: string;
    name: string;
    is_default: boolean;
}

export const createDefaultLocale = (): Locale => ({
    code: 'ro',
    name: 'Română',
    is_default: true,
});